import { render, staticRenderFns } from "./WorkQueue.vue?vue&type=template&id=63b3180f&scoped=true&"
import script from "./WorkQueue.vue?vue&type=script&lang=js&"
export * from "./WorkQueue.vue?vue&type=script&lang=js&"
import style0 from "./WorkQueue.vue?vue&type=style&index=0&id=63b3180f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3180f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
